<template>
    <card shadow>
      <h3 class="h3 title">
        <span class="d-block">Social Proof Badge</span>
      </h3>
      <h6>Download this image for your website and other materials to show you partner with us!</h6>
      <h6 v-show="curOrg.type === 'employer'">Hire our talent to rank up crest levels!</h6>
      <img :src="photoURL" class="img-center img-fluid" />
    </card>
</template>

<script>
import firebase from "@/config/firebase.js";

export default {
  name: "socialproofcard",
  data() {
    return {
      photoURL: ""
    }
  },
  methods: {
    async getPhotoURL() {
      const base = "https://firebasestorage.googleapis.com/v0/b/potential-5635b.appspot.com/o/socialproof%2F";
      const curOrgType = this.$store.state.usermain.curOrg.type;
      switch (curOrgType) {
        case "partner":
          this.photoURL = base + "partner_400x400.png?alt=media";
          break;
        case "agency":
          this.photoURL = base + "agency_400x400.png?alt=media";
          break;
        case "employer":
          var curOrgId = this.$store.state.usermain.curOrg.id
          await firebase
            .firestore()
            .doc(`organizations/${curOrgId}`)
            .get()
            .then((employer) => {
              if(employer.data().employerRank){
                var rank = employer.data().employerRank;
                if(rank === 'bronze'){
                  this.photoURL = base + "employer_bronze_400x400.png?alt=media"
                }else if(rank === 'silver'){
                  this.photoURL =  base + "employer_silver_400x400.png?alt=media"
                }else if(rank === 'gold'){
                  this.photoURL = (base + "employer_gold_400x400.png?alt=media")
                }
              }
            })
            .catch(function(error) {
              console.error(error);
            });
          break;
        default:
          this.photoURL = "";
      }
    }
  },
  computed: {
    curOrg () {
      return this.$store.state.usermain.curOrg;
    },
  },
  watch: {
    curOrg(newCurOrg, _) {
      this.getPhotoURL();
    },
  },
  mounted() {
    this.getPhotoURL();
  }
};
</script>

<style scoped>
</style>
